import React, { useState, useEffect } from 'react';
import { ThinkingState } from '../types'; // Re-use ThinkingState for visibility toggle

interface SearchingProcessProps {
    isSearching: boolean;
    onToggleVisibility?: () => void; // Optional: To show/hide details if needed later
    visibilityState?: ThinkingState; // Optional: To control visibility
    searchTime?: number; // Time spent searching in seconds
}

const SearchingProcess: React.FC<SearchingProcessProps> = ({
    isSearching,
    onToggleVisibility,
    visibilityState = 'hidden',
    searchTime = 0
}) => {
    const [elapsed, setElapsed] = useState(0);
    const [displayTime, setDisplayTime] = useState('0.0s');
    const [timer, setTimer] = useState<NodeJS.Timeout | null>(null);

    // Start a live timer when actively searching
    useEffect(() => {
        if (isSearching) {
            const interval = setInterval(() => {
                setElapsed(prev => {
                    const newElapsed = prev + 0.1;
                    setDisplayTime(`${newElapsed.toFixed(1)}s`);
                    return newElapsed;
                });
            }, 100);

            setTimer(interval);
            return () => clearInterval(interval);
        } else if (timer) {
            clearInterval(timer);
            setTimer(null);
        }
    }, [isSearching]);

    if (!isSearching) return null;

    return (
        <div className="thinking-container active"> {/* Reuse thinking container styles for consistency */}
            <div className="flex items-center justify-between w-full py-2">
                <div className="flex items-center space-x-3">
                    {/* Add animated globe icon */}
                    <div className="animate-pulse text-blue-500">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="2" y1="12" x2="22" y2="12"></line>
                            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                        </svg>
                    </div>
                    {/* Use the shimmer text animation identical to reasoning, but make it more prominent */}
                    <span className="shimmer-text text-lg font-bold">Searching the web...</span>
                    <span className="thinking-time">{displayTime}</span>
                </div>
            </div>
        </div>
    );
};

export default SearchingProcess; 